import { render } from "./ContentFullWidthImage.vue?vue&type=template&id=6e0c8b2a"
import script from "./ContentFullWidthImage.vue?vue&type=script&lang=js"
export * from "./ContentFullWidthImage.vue?vue&type=script&lang=js"

import "./ContentFullWidthImage.vue?vue&type=style&index=0&id=6e0c8b2a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__